export const ROLE_OPTIONS = [
  { value: 'org_admin', label: 'Org Admin' },
  { value: 'executive_director', label: 'Executive Director' },
  { value: 'finance', label: 'Finance/Accounting' },
  { value: 'development', label: 'Development/Fundraising' },
  { value: 'comms', label: 'Program/Comms' },
  { value: 'viewer', label: 'Viewer/Analyst' },
];

export const ROLE_LABELS = ROLE_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.label;
  return acc;
}, {});
